import { useDispatch } from 'react-redux';

import { request } from '!core/api';
import { logoutSlice } from '»components/Auth';
import { navigate } from '»utils/navigation';

export function useHandleSagaError() {
  const dispatch = useDispatch();

  const handleSagaError = (error) => {
    if (error[0].code === '401') {
      navigate('/');
      request.clearHeaders();
      dispatch(
        logoutSlice.actions.logoutSuccess({
          showAlert: true,
          hasInvalidToken: true,
        }),
      );
    }
  };

  return { handleSagaError };
}
